import React from "react";
import aboutImg from "../assets/img/founder2.jpg";
import { Breadcrumb } from "../components/Breadcrumb";
import team1 from '../assets/img/Anjali Dadlani.jpg'
import team2 from '../assets/img/Shivanya.jpg'
import team3 from '../assets/img/Rohan Omer.jpg'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faTwitter, faInstagram, } from "@fortawesome/free-brands-svg-icons";

const About = () => {
    const team = [
        { img: team1, name: "Anjali Dadlani" },
        { img: team2, name: "Shivanya" },
        { img: team3, name: "Rohan Omer" },
    ];
    return (
        <>
            {/* Inline Theme Styles for Tabs */}
            <style>
                {`
          .nav-tabs .nav-link {
            color: var(--text);
            border: none;
            border-bottom: 3px solid transparent;
            background: transparent;
            transition: all 0.3s ease;
          }

          .nav-tabs .nav-link.active {
            color: var(--primary);
            font-weight: 600;
            border-bottom: 3px solid var(--secondary);
            background: var(--light-bg);
          }

          .nav-tabs .nav-link:hover {
            color: var(--primary);
          }

          .tab-content {
            color: var(--text);
          }
        `}
            </style>

            <Breadcrumb currentName={"About"} currentParentName={"About"} />
            {/* ===== About Section ===== */}
            <section
                className="container-xxl py-5"
                style={{ backgroundColor: "var(--light-bg)" }}
            >
                <div className="container">
                    <div className="row g-4 align-items-end mb-4">
                        {/* Left Image */}
                        <div className="col-lg-6">
                            <img
                                className="img-fluid rounded shadow-sm"
                                src={aboutImg}
                                alt="SAG Financials Office"
                                style={{
                                    height:'550px',
                                    border: "4px solid var(--secondary)",
                                }}
                            />
                        </div>

                        {/* Right Text */}
                        <div className="col-lg-6" >
                            <p
                                className="d-inline-block border rounded fw-semi-bold py-1 px-3"
                                style={{
                                    color: "var(--primary)",
                                    borderColor: "var(--primary)",
                                    backgroundColor: "var(--white)",
                                }}
                            >
                                About Us
                            </p>
                            <h1
                                className="display-5 mb-4"
                                style={{ color: "var(--heading)", fontWeight: "700" }}
                            >
                                Real People. Real Goals. Financial Planning with Heart.
                            </h1>

                            <p className="mb-4" style={{ color: "var(--text)" }}>
                                At <strong>SAG Financials</strong>, we’re not just in the
                                business of numbers — we’re in the business of people. People
                                with dreams, responsibilities, and unique financial journeys.
                                Since our founding in <strong>2017</strong>, we’ve committed
                                ourselves to helping individuals and families navigate life’s
                                financial decisions with clarity, confidence, and care.
                            </p>

                            {/* Tabs */}
                            <div
                                className="border rounded p-4"
                                style={{
                                    borderColor: "var(--secondary)",
                                    backgroundColor: "var(--white)",
                                }}
                            >
                                <nav>
                                    <div className="nav nav-tabs mb-3" id="nav-tab" role="tablist">
                                        <button
                                            className="nav-link active fw-semi-bold"
                                            id="nav-story-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#nav-story"
                                            type="button"
                                            role="tab"
                                            aria-controls="nav-story"
                                            aria-selected="true"
                                        >
                                            How We Started
                                        </button>
                                        <button
                                            className="nav-link fw-semi-bold"
                                            id="nav-mission-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#nav-mission"
                                            type="button"
                                            role="tab"
                                            aria-controls="nav-mission"
                                            aria-selected="false"
                                        >
                                            Our Founder
                                        </button>
                                        <button
                                            className="nav-link fw-semi-bold"
                                            id="nav-vision-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#nav-vision"
                                            type="button"
                                            role="tab"
                                            aria-controls="nav-vision"
                                            aria-selected="false"
                                        >
                                            In Her Words
                                        </button>
                                    </div>
                                </nav>

                                <div className="tab-content" id="nav-tabContent">
                                    {/* How We Started */}
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-story"
                                        role="tabpanel"
                                        aria-labelledby="nav-story-tab"
                                    >
                                        <p>
                                            <strong>SAG Financials</strong> was born out of both
                                            expertise and empathy. Our founder,
                                            <strong> Shepra Anand</strong>, spent more than two decades
                                            working with leading financial institutions — including
                                            ICICI Bank, IDBI Federal Life, Aditya Birla Sun Life, and
                                            Religare Broking.
                                        </p>
                                        <p className="mb-0">
                                            In 2017, she founded <strong>SAG Financials</strong> — a
                                            company built around people, not products. Since then,
                                            we’ve helped hundreds of clients plan smarter and live
                                            more securely.
                                        </p>
                                    </div>

                                    {/* Our Founder */}
                                    <div
                                        className="tab-pane fade"
                                        id="nav-mission"
                                        role="tabpanel"
                                        aria-labelledby="nav-mission-tab"
                                    >
                                        <p>
                                            <strong>Shepra Anand</strong> — CEO & Founder, Certified
                                            Financial Advisor with 22+ years in the industry, AMFI,
                                            IRDA & NISM certified.
                                        </p>
                                        <ul>
                                            <li>
                                                Train the Trainer Certification by Aditya Birla Sun Life
                                            </li>
                                            <li>
                                                3× Felicitation by IDBI Federal Life CEO at National
                                                Conventions
                                            </li>
                                            <li>
                                                5× Gold & Platinum Club recognition by Aditya Birla Sun
                                                Life
                                            </li>
                                            <li>
                                                MDRT (Million Dollar Round Table) global achievement
                                            </li>
                                        </ul>
                                    </div>

                                    {/* In Her Words */}
                                    <div
                                        className="tab-pane fade"
                                        id="nav-vision"
                                        role="tabpanel"
                                        aria-labelledby="nav-vision-tab"
                                    >
                                        <p style={{ fontStyle: "italic" }}>
                                            “Finance doesn’t have to be scary or confusing. It should
                                            be empowering and aligned with your goals.”
                                        </p>
                                        <p className="mb-0" style={{ color: "var(--heading)" }}>
                                            <strong>
                                                — Shepra Anand, CEO & Founder, SAG Financials
                                            </strong>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

         
                    {/* ===== Feature Section ===== */}
                    <div
                        className="border rounded p-4"
                        style={{
                            borderColor: "var(--secondary)",
                            backgroundColor: "var(--white)",
                        }}
                    >
                        <div className="row g-4">
                            {[
                                {
                                    icon: "fa-heart",
                                    title: "Personalized Advice",
                                    text: "We focus on people, not products — offering guidance that fits your life and goals.",
                                },
                                {
                                    icon: "fa-users",
                                    title: "Trusted Expertise",
                                    text: "Over two decades of experience in top financial institutions, delivered with empathy.",
                                },
                                {
                                    icon: "fa-handshake",
                                    title: "Relationships That Last",
                                    text: "We believe in lifelong relationships built on trust, clarity, and care.",
                                },
                            ].map((item, i) => (
                                <div key={i} className="col-lg-4">
                                    <div className="d-flex align-items-start">
                                        <div
                                            className="flex-shrink-0 btn-lg-square rounded-circle"
                                            style={{
                                                backgroundColor: "var(--primary)",
                                                width: "50px",
                                                height: "50px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <i
                                                className={`fa ${item.icon}`}
                                                style={{ color: "var(--white)" }}
                                            ></i>
                                        </div>
                                        <div className="ps-3">
                                            <h4 style={{ color: "var(--heading)" }}>{item.title}</h4>
                                            <span style={{ color: "var(--text)" }}>{item.text}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

            </section>
            {/* ===== Team Philosophy ===== */}
            <section
                className="container-xxl py-5"
                style={{ backgroundColor: "var(--light-bg)" }}
            >
                <div className="container">
                    <div className="text-center mx-auto d-none" style={{ maxWidth: "700px" }}>
                        <p
                            className="d-inline-block border rounded fw-semi-bold py-1 px-3"
                            style={{
                                color: "var(--primary)",
                                borderColor: "var(--primary)",
                                backgroundColor: "var(--white)",
                            }}
                        >
                            Our Team
                        </p>
                        <h1
                            className="display-5 mb-4"
                            style={{ color: "var(--heading)", fontWeight: "700" }}
                        >
                            Meet the Team Behind SAG Financials
                        </h1>
                        <p className="mb-4" style={{ color: "var(--text)" }}>
                            Our boutique firm of 2–10 professionals brings expertise across
                            investment planning, insurance, taxation, and digital finance.
                        </p>
                    </div>
   {/* ===== Team Section ===== */}
            <section
                className="container-xxl py-5"
                style={{ backgroundColor: "var(--light-bg)" }}
            >
                <div className="container">
                    <div
                        className="text-center mx-auto"
                        style={{ maxWidth: "600px" }}
                    >
                        <p
                            className="d-inline-block border rounded fw-semi-bold py-1 px-3"
                            style={{
                                color: "var(--primary)",
                                borderColor: "var(--primary)",
                                backgroundColor: "var(--white)",
                            }}
                        >
                            Our Team
                        </p>
                        <h1
                            className="display-5 mb-5"
                            style={{ color: "var(--heading)", fontWeight: "700" }}
                        >
                            Exclusive Team
                        </h1>
                    </div>

                    <div className="row g-4">
                        {team.map((member, i) => (
                            <div
                                key={i}
                                className="col-lg-4 col-md-6"
                                style={{
                                    animation: "fadeInUp 0.8s ease",
                                    animationDelay: `${0.1 + i * 0.2}s`,
                                }}
                            >
                                <div
                                    className="team-item rounded overflow-hidden shadow-sm"
                                    style={{
                                        border: "3px solid var(--secondary)",
                                        borderRadius: "12px",
                                        backgroundColor: "var(--white)",
                                        transition: "transform 0.4s ease, box-shadow 0.4s ease",
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = "translateY(-8px)";
                                        e.currentTarget.style.boxShadow = "0 10px 25px rgba(0,0,0,0.15)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "translateY(0)";
                                        e.currentTarget.style.boxShadow = "none";
                                    }}
                                >
                                    <img
                                        className="img-fluid rounded w-100"
                                        src={member.img}
                                        alt={member.name}
                                        style={{
                                            objectFit: "cover",
                                            borderBottom: "3px solid var(--secondary)",
                                            height: 350
                                        }}
                                    />

                                    <div
                                        className="team-text text-center py-3"
                                        style={{ backgroundColor: "var(--white)" }}
                                    >
                                        <h4
                                            className="mb-0"
                                            style={{ color: "var(--heading)", fontWeight: "600" }}
                                        >
                                            {member.name}
                                        </h4>

                                        <div className="team-social d-flex justify-content-center mt-3 d-none">
                                            {[
                                                { icon: faFacebookF, color: "#1877F2" },
                                                { icon: faTwitter, color: "#1DA1F2" },
                                                { icon: faInstagram, color: "#E4405F" },
                                            ].map((social, index) => (
                                                <a
                                                    key={index}
                                                    className="btn btn-square rounded-circle mx-1"
                                                    href="#"
                                                    style={{
                                                        width: "38px",
                                                        height: "38px",
                                                        backgroundColor: "var(--primary)",
                                                        color: "var(--white)",
                                                        transition: "all 0.3s ease",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor = social.color;
                                                        e.currentTarget.style.color = "var(--white)";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor = "var(--primary)";
                                                        e.currentTarget.style.color = "var(--white)";
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={social.icon} />
                                                </a>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
                    <div className="row g-4 mb-5">
                        <div className="col-lg-6">
                            <h4
                                className="mb-3"
                                style={{ color: "var(--primary)", fontWeight: "600" }}
                            >
                                Every Member of Our Team
                            </h4>
                            <ul className="list-unstyled" style={{ color: "var(--text)" }}>
                                <li>• Certified by AMFI, IRDA, or NISM</li>
                                <li>• Committed to client-first advisory</li>
                                <li>• Clear and empathetic communication</li>
                                <li>• Passionate about simplifying finance</li>
                            </ul>
                        </div>

                        <div className="col-lg-6">
                            <h4
                                className="mb-3"
                                style={{ color: "var(--primary)", fontWeight: "600" }}
                            >
                                What We Stand For
                            </h4>
                            <ul className="list-unstyled" style={{ color: "var(--text)" }}>
                                <li>🌱 Clarity Over Complexity</li>
                                <li>🤝 Relationships Over Transactions</li>
                                <li>💡 Education Over Pressure</li>
                                <li>🌍 Digital by Design, Human at Heart</li>
                            </ul>
                        </div>
                    </div>

                    <div className="row g-4 mb-5">
                        <div className="col-lg-12">
                            <h4
                                className="mb-3"
                                style={{ color: "var(--primary)", fontWeight: "600" }}
                            >
                                Our Clients, Our Community
                            </h4>
                            <p style={{ color: "var(--text)" }}>
                                We’re honored to serve professionals, families, retirees, and
                                entrepreneurs — all seeking financial clarity and confidence.
                            </p>
                        </div>
                    </div>

                    <div className="row g-4">
                        <div className="col-lg-12">
                            <h4
                                className="mb-3"
                                style={{ color: "var(--primary)", fontWeight: "600" }}
                            >
                                Looking Forward
                            </h4>
                            <p style={{ color: "var(--text)" }}>
                                As we continue to grow, our mission remains the same: to be your
                                lifelong financial partner — today, tomorrow, and beyond.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default About;
